import { render, staticRenderFns } from "./CommentQuote.vue?vue&type=template&id=ddc1e164&scoped=true&"
import script from "./CommentQuote.vue?vue&type=script&lang=js&"
export * from "./CommentQuote.vue?vue&type=script&lang=js&"
import style0 from "./CommentQuote.vue?vue&type=style&index=0&id=ddc1e164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc1e164",
  null
  
)

export default component.exports